




























import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import MemberApi from '@/apis/MemberApi';
import MemberChangeNameRequestModel from '@/models/member/MemberChangeNameRequestModel';

@Component({
        name: 'MemberChangeName',
    },
)
export default class MemberChangeName extends ViewBase {

    public givenName: string = '';
    public surname: string = '';

    public givenNameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A first name is required.';
        }

        return true;
    }

    public surnameRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A last name is required.';
        }

        return true;
    }

    public created() {
        this.givenName = this.$store.state.member.givenName;
        this.surname = this.$store.state.member.surname;
    }

    public async saveClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new MemberChangeNameRequestModel();
                request.givenName = this.givenName;
                request.surname = this.surname;

                const api = new MemberApi();
                const response = await api.changeNameAsync(this.$store.state.member.jwt, request);

                this.$store.commit('mutateMemberGivenName', this.givenName);
                this.$store.commit('mutateMemberSurname', this.surname);
                this.$store.commit('mutateSnackbarText', 'Your name has been changed.');
                this.$store.commit('mutateShowSnackbar', true);

                await this.$router.push({name: 'memberprofile'});
            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.changeMemberNameForm;

        return form.validate();
    }

}

